// extracted by mini-css-extract-plugin
export const shipCard = "ShipCard-module--ship-card--2p5e4";
export const variantRight = "ShipCard-module--variant-right--1aJjt";
export const variantLeft = "ShipCard-module--variant-left--2pqPi";
export const nameContainer = "ShipCard-module--name-container--24EdB";
export const title = "ShipCard-module--title--13JXn";
export const shipType = "ShipCard-module--ship-type--GAlyv";
export const description = "ShipCard-module--description--3dAHf";
export const image = "ShipCard-module--image--2tPbS";
export const techDetailsContainer = "ShipCard-module--tech-details-container--32mwd";
export const techDetails = "ShipCard-module--tech-details--ppqt1";
export const techDetail = "ShipCard-module--tech-detail--3vBp6";
export const techDetailLabel = "ShipCard-module--tech-detail-label--2lEd8";
export const techDetailValue = "ShipCard-module--tech-detail-value--2ocwE";
export const facilitiesContainer = "ShipCard-module--facilities-container--3fm8i";
export const facilities = "ShipCard-module--facilities--1CKh6";
export const footer = "ShipCard-module--footer--3dtRH";